$( document ).ready(function() {
  const CheckboxInput = $( ".checkbox__input" );
  const CheckboxLabel = $( ".checkbox__label" );
  if ( CheckboxInput.parent().is( ".field_with_errors" ) ) {
    CheckboxInput.unwrap();
  }

  if ( CheckboxLabel.parent().is( ".field_with_errors" ) ) {
    CheckboxLabel.unwrap();
  }
});
